import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { useFormik } from "formik"
import { exportDataExcel } from "components/Common/ExportData"
import WorkerHolidayTable from "./WorkerHolidayTable"
import { dateFormat, dateTimeFormatIOS } from "pages/Common"
import Flatpickr from "react-flatpickr";

function WorkerHoliday() {
  document.title = `Workers Holiday | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [holidayId, setHolidayId] = useState(0)
  const [isActive, setIsActive] = useState(true)
  const [date, setDate] = useState(new Date());

  // worker holiday list api
  const workerHolidayListApi = () => {
    setScreenLoad(true)
    setIsLoading(true)
    getApi(`Common/holiday/list`).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
        setTotalRecords(data.length)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setScreenLoad(false)
    })
  }

  // worker holiday list api useEffect
  useEffect(() => {
    workerHolidayListApi()
  }, [])

  // toggle handlers
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Delete worker holiday handler
  const handleDelete = (holidayId) => {
    setScreenLoad(true)
    if (holidayId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this holidat permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/holiday/delete?id=${holidayId}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== holidayId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("successfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Master",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update worker holiday handler
  const handleEditHoliday = (Holidaysdata) => {
    if (Holidaysdata) {
      setHolidayId(Holidaysdata.Id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(Holidaysdata)
    }
  }

  // Create worker holiday handler
  const handleHolidayClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Workers Holiday Validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: isEdit ? editData?.Name : "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The holiday name is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        postApi("Common/holiday/addedit", {
          id: isEdit ? parseInt(holidayId) : 0,
          Name: values.Name,
          Date: dateTimeFormatIOS(date),
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "successfully updated" : "successfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            workerHolidayListApi()
            validation.handleReset()
          }
        })
      }
    },
  })

  // worker holiday table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Date",
        accessor: "Date",
        width: "9%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.Date == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.Date?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        width: "8%",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditHoliday(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  id={`deletetooltip${row.original.Id}`}
                  className="fs-6 fas fa-trash-alt btn-delete"
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Name", "Date"];
    const mainTitle = "Workers Holiday";
    const widthObj = [{
      Key: "A",
      Value: 30,
    },
    {
      Key: "B",
      Value: 18,
    },
    ]
    const extention = "Holidays.xlsx"
    let excelSheetData = []
    for (let index = 0; index < tableData?.length; index++) {
      let dataObj = {
        Name: tableData[index]?.Name,
        Date: tableData[index]?.Date == null
          ? "N/A"
          : dateFormat(tableData[index].Date, "dd-MM-yyyy"),
      }
      excelSheetData.push(dataObj)
    }
    var fields = Object.keys(excelSheetData[0]);
    var sheetData = excelSheetData.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName];
      });
    });
    setIsLoading(false)
    sheetData.unshift(header);
    exportDataExcel(sheetData, mainTitle, widthObj, extention)
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <WorkerHolidayTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isCategoryList={true}
              handleHolidayClick={handleHolidayClick}
              customPageSize={10}
              className="custom-header-css"
              isLoading={isLoading}
              TotalRecords={totalRecords}
              writeDataToExcel={writeDataToExcel}
              setIsActive={setIsActive}
              isActive={isActive}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "350px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Holiday" : "Create Holiday"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03" className="required">
                          Name
                        </Label>
                        <Input
                          name="Name"
                          placeholder="Holiday Name"
                          type="text"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.Name || ""}
                          invalid={
                            validation.touched.Name && validation.errors.Name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Name && validation.errors.Name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Name}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>
                    <Row>
                      <FormGroup className="mb-2">
                        <Label
                          htmlFor="validationCustom03"
                          className="required"
                        >
                          Date
                        </Label>
                        <div className="d-flex date-after" >
                          <Flatpickr
                            className="form-control d-block flatpicker-date"
                            placeholder="dd-MM-yyyy"
                            options={{
                              // enableTime: true,
                              dateFormat: "d-m-Y",
                              disableMobile: true
                            }}
                            value={date}
                            onChange={(e) => { setDate(e) }}
                          />
                        </div>
                      </FormGroup>
                    </Row>

                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm"
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div >
  )
}
WorkerHoliday.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default WorkerHoliday